import * as React from 'react';
import { UserContext } from '../../Models/UserProfile';
import { useState } from 'react';
import { store } from '../../Store';
import { DropdownDataState } from '../Reducers/DropdownData';
import { DropdownService } from 'src/Services/DropdownService';
import { useDispatch } from 'react-redux';
import { setDropdownData } from 'src/actions/Actions';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { appInsights } from 'src/Services/Insights';
import { UATConstants } from 'src/Common/Models/UATConstants';

export enum TargetRedirection {
  ErrorPage,
  HomePage,
}

interface DataLoadProps {
  user: UserContext;
  redirectTarget?: TargetRedirection;
  children?: any;
  loadDropDown?: boolean;
}

const DataLoader: React.FC<DataLoadProps> = ({ ...props }) => {
  const [reRender, setReRender] = useState<boolean>(false);
  const isLoadingDropdownDataRef = React.useRef<boolean>(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (props.loadDropDown) {
      const dropDownData: DropdownDataState = store.getState().dropdownData;
      if (!dropDownData.isDataLoaded && !isLoadingDropdownDataRef.current) {
        getDropdownData();
      }
    }
  }, []);

  const getDropdownData = () => {
    if (isLoadingDropdownDataRef.current) {
      return;
    }
    isLoadingDropdownDataRef.current = true;
    DropdownService.fetchDropdownData(
      (response: DropdownDataState) => {
        response.isDataLoaded = true;
        dispatch(setDropdownData(response));
        setReRender(v => !v);
        isLoadingDropdownDataRef.current = false;

        appInsights.trackEvent({
          name: 'Dropdowns API Call successful- Data Loaded',
          properties: {
            username: props.user.displayName,
            email: props.user.email,
            flights: props.user.flights,
          },
        });
      },
      () => {
        isLoadingDropdownDataRef.current = false;
      }
    );
  };
  if (props.loadDropDown) {
    const dropDownValues: DropdownDataState = store.getState().dropdownData;
    if (dropDownValues.isDataLoaded) {
      return props.children;
    } else {
      return (
        <Spinner
          size={SpinnerSize.large}
          label={UATConstants.PlaceholdersAndTitles.Loading}
          ariaLive='assertive'
          className='loading-panel-full'
        />
      );
    }
  }
};

export default DataLoader;
